import type { Database } from '@/types/database';

export type TicketStatus = Database['public']['Enums']['ticket_status'];
export type Ticket = Database['public']['Tables']['tickets']['Row'];

export const STATUS_LABELS: Record<TicketStatus, string> = {
  open: 'Aberto',
  in_progress: 'Em andamento',
  resolved: 'Resolvido',
};

export const STATUS_BADGE_CLASSES: Record<TicketStatus, string> = {
  open: 'bg-warning/15 text-warning border-warning/30',
  in_progress: 'bg-primary/15 text-primary border-primary/30',
  resolved: 'bg-income/15 text-income border-income/30',
};

export const ALLOWED_MIME_TYPES = [
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/webp',
  'video/mp4',
  'video/quicktime',
  'video/webm',
];

export const MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024; // 50MB
export const MAX_FILE_SIZE_LABEL = '50MB';
